export const QUESTIONS = [
  {
    id: 1,
    q: "안개 낀 숲의 입구, 당신의 발걸음은 어떤가요?",
    img: "/images/q1.jpg",
    a: [
      { text: "조심스럽게 주변을 살피며 천천히 걷는다.", type: "I", weight: 2, choice: "A" },
      { text: "설렘을 안고 거침없이 숲 안쪽으로 나아간다.", type: "E", weight: 2, choice: "B" }
    ]
  },
  {
    id: 2,
    q: "길을 가다 낯선 갈림길이 나타났습니다. 당신의 선택은?",
    img: "/images/q2.jpg",
    a: [
      { text: "직관적으로 더 끌리는 길을 선택한다.", type: "W", weight: 2, choice: "A" },
      { text: "지도를 꺼내 지형을 꼼꼼히 분석해본다.", type: "S", weight: 2, choice: "B" }
    ]
  },
  {
    id: 3,
    q: "야영지 선정 중에 동료들 사이에 의견 차이가 생겼습니다.",
    img: "/images/q3.jpg",
    a: [
      { text: "갈등을 해결하기 위해 중재안을 제시한다.", type: "S", weight: 2, choice: "A" },
      { text: "혼자 조용히 가장 좋은 장소를 찾아 나선다.", type: "I", weight: 2, choice: "B" }
    ]
  },
  {
    id: 4,
    q: "어두운 수풀 속에서 정체불명의 부스럭거리는 소리가 들립니다.",
    img: "/images/q4.jpg",
    a: [
      { text: "정체를 확인하기 위해 조심스럽게 다가간다.", type: "E", weight: 2, choice: "A" },
      { text: "본능적으로 무기를 잡고 경계 태세를 갖춘다.", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 5,
    q: "모닥불이 타오르는 밤, 당신은 어떤 모습인가요?",
    img: "/images/q5.jpg",
    a: [
      { text: "오늘 겪은 모험 이야기를 동료들과 나눈다.", type: "E", weight: 2, choice: "A" },
      { text: "타오르는 불꽃을 보며 깊은 생각에 잠긴다.", type: "I", weight: 2, choice: "B" }
    ]
  },
  {
    id: 6,
    q: "내일의 탐험을 계획할 때, 당신의 스타일은?",
    img: "/images/q6.jpg",
    a: [
      { text: "목적지까지의 최단 거리와 보급을 철저히 계산한다.", type: "S", weight: 2, choice: "A" },
      { text: "상황에 따라 유동적으로 움직이기로 한다.", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 7,
    q: "동료가 실수로 지도를 잃어버렸을 때, 당신의 반응은?",
    img: "/images/q7.jpg",
    a: [
      { text: "기억을 더듬어 지형지물을 파악하려 노력한다.", type: "S", weight: 2, choice: "A" },
      { text: "지도 없는 모험도 나쁘지 않다며 동료를 다독인다.", type: "E", weight: 2, choice: "B" }
    ]
  },
  {
    id: 8,
    q: "한 번도 본 적 없는 웅장한 고대 유적을 발견했습니다!",
    img: "/images/q8.jpg",
    a: [
      { text: "유적의 벽화와 기록을 분석하며 역사를 유추한다.", type: "I", weight: 2, choice: "A" },
      { text: "보물이 있을 만한 곳을 본능적으로 찾아낸다.", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 9,
    q: "험난한 탐험 중에 당신이 가장 많이 듣는 말은?",
    img: "/images/q9.jpg",
    a: [
      { text: "정말 계획적이고 꼼꼼하시네요.", type: "S", weight: 2, choice: "A" },
      { text: "어떻게 그런 과감한 결정을 내리시나요?", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 10,
    q: "좁고 위험해 보이는 동굴 입구에 도착했습니다.",
    img: "/images/q10.jpg",
    a: [
      { text: "먼저 들어가 동굴 안의 안전을 확인한다.", type: "E", weight: 2, choice: "A" },
      { text: "외부에서 동굴의 구조를 충분히 살핀 뒤 움직인다.", type: "I", weight: 2, choice: "B" }
    ]
  },
  {
    id: 11,
    q: "긴 탐험 끝에 에너지를 보충하는 당신만의 방식은?",
    img: "/images/q11.jpg",
    a: [
      { text: "동료들과 성대한 식사를 하며 활기를 얻는다.", type: "E", weight: 2, choice: "A" },
      { text: "나무 그늘 아래서 혼자 낮잠을 자며 휴식한다.", type: "I", weight: 2, choice: "B" }
    ]
  },
  {
    id: 12,
    q: "지금 당신의 배낭 속에 있는 물건들의 상태는 어떤가요?",
    img: "/images/q12.jpg",
    a: [
      { text: "필요한 물건이 어디 있는지 정확히 분류되어 있다.", type: "S", weight: 2, choice: "A" },
      { text: "필요한 게 있으면 바로 꺼낼 수 있게 자유롭게 담겨 있다.", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 13,
    q: "탐험 중 길을 잃은 아기 희귀 동물을 발견했습니다.",
    img: "/images/q13.jpg",
    a: [
      { text: "무리에게 안전하게 돌아갈 수 있게 길을 찾아준다.", type: "S", weight: 2, choice: "A" },
      { text: "동물의 행동을 관찰하며 본능적인 교감을 시도한다.", type: "W", weight: 2, choice: "B" }
    ]
  },
  {
    id: 14,
    q: "저 멀리 앞서가는 다른 탐험대가 보입니다. 경쟁심이 생기나요?",
    img: "/images/q14.jpg",
    a: [
      { text: "우리의 페이스를 유지하며 끝까지 완주한다.", type: "I", weight: 2, choice: "A" },
      { text: "더 빨리 나아가 우리가 먼저 목표를 달성한다.", type: "E", weight: 2, choice: "B" }
    ]
  },
  {
    id: 15,
    q: "내일이면 이 긴 탐험이 끝난다는 소식을 들었습니다.",
    img: "/images/q15.jpg",
    a: [
      { text: "그동안 기록한 탐험 일지를 꼼꼼히 정리한다.", type: "S", weight: 2, choice: "A" },
      { text: "마지막 밤을 즐기며 다음 모험을 꿈꾼다.", type: "W", weight: 2, choice: "B" }
    ]
  }
];